import React, { useEffect, useState } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import '../../assets/style/TaskAssign.css';
import { Button, Col, Image, Row } from 'react-bootstrap';
import MSelect from '../../components/MSelect';
import MTextField from '../../components/MTextField';
import MDatePicker from '../../components/MDatePicker';
import Calendar from '../../assets/img/calendar.svg';
import Search from '../../assets/img/search.svg';
import Cancel from '../../assets/img/circleCancel.svg';
import successTick from '../../assets/img/successTick.svg';
import DisablesuccessTick from '../../assets/img/disableSuccess.svg';
import {
  CLICK_ACTIONS,
  LEAD_STATUS_OPTIONS,
  TASK_ACTION,
} from '../../utils/Constant';
import {
  ColXsMdType,
  CreateLeadLocationDataType,
  EmployeeNameType,
  LeadDetailsType,
  LeadItemType,
  MUILocationFilterType,
  SelectOptionType,
} from '../../utils/Types';
import { fetchEmployeeNames, taskSelector } from '../../features/taskSlice';
import { SelectChangeEvent } from '@mui/material/Select';
import moment from 'moment';
import MAutoComplete from '../../components/MAutoComplete';
import CenterSpinner from '../../components/CenterSpinner';
import { getNoteDate } from '../../utils/Util';
import { useNavigate } from 'react-router-dom';
import {
  fetchLeadStatusDrops,
  fetchLeadTypeDrops,
  leadSelector,
} from '../../features/leadSlice';
import MUILocationFilter from '../../components/MUILocationFilter';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  assignTask,
  createLead,
  findSelectedLeadDetails,
  saveComment,
  updateLeadStatus,
} from './LeadPageHelper';
import {
  getDefaultLocation,
  getEmployee,
  getEmployeeNameList,
  getLocation,
  updateSelectedEmployee,
} from '../task-assigned/TaskAssignHelper';
import { useLoader } from '../../loader/LoaderProvider';

const blankSelectedEmployee: EmployeeNameType = {
  employeeName: '',
  roleName: '',
  roleId: '',
  mobileNumber: '',
  employeeUniqueId: '',
  candidateId: '',
};
const blankLocation = {
  sl: '',
  pincode: '',
  location: '',
  district: '',
  state: null,
  city: '',
  statecode: '',
  statecd: '',
  pincodecol: '',
  did: '',
  zone: '',
  zones: '',
};
interface ICreateTaskPageProps {
  title?: string;
  leadToView?: LeadItemType;
  leadStatusName?: string;
  onTaskAction?: (action: string) => void;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const CreateLeadPage: React.FunctionComponent<ICreateTaskPageProps> = ({
  title,
  onTaskAction,
  leadToView,
  leadStatusName,
}: ICreateTaskPageProps) => {
  const [leadStatus, setLeadStatus] = useState(TASK_ACTION.CREATE);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [leadUniqueId, setLeadUniqueId] = useState('');
  const { showLoader, setShowLoader } = useLoader();
  const leadTypeOptions: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeOptions;
  const [selectedLeadTypeId, setSelectedLeadTypeId] = useState<number>();
  const [leadTypeDropOptions, setLeadTypeDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [optionEmployeeName, setOptionEmployeeName] = useState<
    SelectOptionType[]
  >([]);
  const [leadDetails, setLeadDetails] = useState<any>({});
  const [locationData, setLocationData] =
    useState<CreateLeadLocationDataType>(blankLocation);
  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeNameType>(
    blankSelectedEmployee
  );
  const [completionDateTime, setCompletionDateTime] = useState(
    moment(new Date()).format('DD-MM-YYYY H:mm')
  );
  const [comment, setComment] = useState<string>();
  const statusDropOptions: SelectOptionType[] =
    useAppSelector(leadSelector).statusDropOptions;
  const [optionTaskStatus, setOptionTaskStatus] = useState<number>();
  const [leadStatusDropOptions, setLeadStatusDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [leadToViewDetails, setLeadToViewDetails] = useState<LeadDetailsType>();
  const [defaultLocationOptions, setDefaultLocationOptions] = useState<any>({});
  const employeeList: EmployeeNameType[] =
    useAppSelector(taskSelector).employeeList;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const navigateToViewListPage = () => {
    clearFields();
  };

  const clearFields = () => {
    setSelectedLeadTypeId(undefined);
    setSelectedEmployee(blankSelectedEmployee);
    setLeadDetails({
      name: '',
      contactNumber: '',
    });
    setLocationData(blankLocation);
    setComment('');
    setCompletionDateTime(moment().format('DD-MM-YYYY H:mm'));
  };

  /**
   * Handling the Lead Details when click on the view leads page and Setting the data to variables
   */
  const handleLeadsData = (leadDetails?: LeadDetailsType) => {
    if (leadDetails) {
      setSelectedLeadTypeId(leadDetails.leadTypeId);
      setSelectedEmployee(getEmployee(leadDetails));
      setLeadDetails({
        name: leadDetails.leadName,
        contactNumber: leadDetails.leadNumber,
      });
      setLocationData(getLocation(leadDetails));
      setDefaultLocationOptions(getDefaultLocation(leadDetails));
      setOptionTaskStatus(leadDetails.leadStatus);
      let filteredValues = [...statusDropOptions];

      if (leadDetails.leadStatus !== LEAD_STATUS_OPTIONS.NEW) {
        filteredValues = statusDropOptions.filter(
          (item) => item.value !== LEAD_STATUS_OPTIONS.NEW
        );

        if (leadDetails.leadStatus !== LEAD_STATUS_OPTIONS.FOLLOW_UP) {
          filteredValues = filteredValues.filter(
            (item) => item.value !== LEAD_STATUS_OPTIONS.FOLLOW_UP
          );
        }
      }
      setLeadStatusDropOptions(filteredValues);
      setLeadUniqueId(leadDetails.leadId);
      setCompletionDateTime(
        moment.utc(leadDetails.leadReceivedOn).local().format('DD-MM-YYYY H:mm')
      );
    } else {
      setLeadUniqueId(`LID-O-${moment(new Date()).format('DDMMYY')}-`);
    }
  };

  /**
   * Handling the Lead Type dropdown value.
   */
  const onTaskNameChange = (selectedName: SelectChangeEvent) => {
    const value = Number(selectedName.target.value);
    setSelectedLeadTypeId(value);
  };

  /**
   * Fetches Lead Types,Lead Status and Employee Names from the API.
   */
  const fetchEmployeeNamesList = () => {
    dispatch(fetchLeadTypeDrops());
    dispatch(fetchLeadStatusDrops({ module: 4 }));
    dispatch(fetchEmployeeNames());
  };
  useEffect(() => {
    setOptionEmployeeName(getEmployeeNameList(employeeList));
  }, [employeeList]);
  useEffect(() => {
    setLeadStatus(leadStatusName ?? TASK_ACTION.CREATE);
    if (leadStatusName && leadStatusName === TASK_ACTION.VIEW) {
      setDisabled(true);
    }
    fetchEmployeeNamesList();
  }, [leadStatusName]);

  useEffect(() => {
    if (!leadStatusName && statusDropOptions?.length) {
      const initStatusValue = statusDropOptions?.filter(
        (item) => item.label === 'New'
      );
      setOptionTaskStatus(Number(initStatusValue[0].value));
    }
    if (statusDropOptions?.length) {
      setLeadStatusDropOptions(statusDropOptions);
    }
  }, [statusDropOptions, leadStatusName]);

  useEffect(() => {
    if (leadToView?.leadId) {
      findSelectedLeadDetails(
        setShowLoader,
        dispatch,
        handleLeadsData,
        setLeadToViewDetails,
        leadToView.leadId
      );
    } else {
      setLeadUniqueId(`LID-O-${moment(new Date()).format('DDMMYY')}-`);
    }
  }, [leadToView]);
  /**
   * Filtering Lead type options for the create lead
   */
  useEffect(() => {
    if (leadToView?.leadId) {
      setLeadTypeDropOptions(leadTypeOptions);
    } else {
      const filterFieldTypeVal =
        leadTypeOptions?.filter(({ value }) => value == 1) || [];
      setLeadTypeDropOptions(filterFieldTypeVal);
    }
  }, [leadToView, leadTypeOptions]);

  return (
    <div>
      <Label className="text-heading">{title ?? 'Create Lead'}</Label>
      <div className="container-parent task-item-parent-view">
        <Row className="task-details pb-2">
          <Col xs={12} md={4}>
            <MTextField
              label="Lead Id"
              value={leadUniqueId}
              onChange={(event) => {
                setLeadUniqueId(event.target.value);
              }}
              disabled
            />
          </Col>

          <Col xs={12} md={4} className="col-margin">
            <MSelect
              label="Lead Type"
              required
              disabled={disabled}
              options={leadTypeDropOptions}
              value={selectedLeadTypeId}
              onChange={onTaskNameChange}
            />
          </Col>
        </Row>
        {optionTaskStatus && optionTaskStatus !== LEAD_STATUS_OPTIONS.NEW && (
          <div className="inner-div mt-2">
            <Label className="header-style">Assigned To</Label>
            <Row className="mt-1">
              <Col xs={leadStatus !== TASK_ACTION.CREATE ? 7 : 12} md={4}>
                <MAutoComplete
                  label="Employee Name"
                  options={optionEmployeeName}
                  value={{
                    value: selectedEmployee.candidateId,
                    label: selectedEmployee.employeeName.trim(),
                  }}
                  onChange={(value: any) => {
                    updateSelectedEmployee(
                      value,
                      employeeList,
                      setSelectedEmployee
                    );
                  }}
                  icon={<Image src={Search}></Image>}
                  disabled={
                    !!(
                      leadToView?.leadId &&
                      leadToViewDetails?.leadStatus !==
                        LEAD_STATUS_OPTIONS.FOLLOW_UP
                    )
                  }
                />
              </Col>
              {leadStatus !== TASK_ACTION.CREATE && (
                <Col xs={4} md={4}>
                  <Button
                    variant="primary"
                    className="cl-btn-primary mt-2 assign-button"
                    disabled={
                      showLoader ||
                      (selectedEmployee?.candidateId ?? '') ===
                        (leadToViewDetails?.assignedToEmployeeUniqueId ?? '') ||
                      !!(
                        leadToView?.leadId &&
                        leadToViewDetails?.leadStatus !==
                          LEAD_STATUS_OPTIONS.FOLLOW_UP
                      )
                    }
                    onClick={() => {
                      assignTask(
                        {
                          leadId: leadUniqueId,
                          assignedToId: selectedEmployee.candidateId || null,
                        },
                        setShowLoader,
                        dispatch,
                        handleLeadsData,
                        setLeadToViewDetails
                      );
                    }}
                  >
                    Assign Lead
                  </Button>
                </Col>
              )}
            </Row>
            <Row className="mt-3">
              <Col xs={12} md={4}>
                <MTextField
                  label="Role"
                  value={selectedEmployee?.roleName}
                  onChange={(event: any) => {
                    setSelectedEmployee({
                      ...selectedEmployee,
                      roleName: event.target.value,
                    });
                  }}
                  disabled
                />
              </Col>
              <Col xs={12} md={4} className="col-margin">
                <MTextField
                  label="Employee Id"
                  value={selectedEmployee?.employeeUniqueId}
                  onChange={(event: any) => {
                    setSelectedEmployee({
                      ...selectedEmployee,
                      employeeUniqueId: event.target.value,
                    });
                  }}
                  disabled
                />
              </Col>
              <Col xs={12} md={4} className="col-margin">
                <MTextField
                  label="Mobile Number"
                  value={selectedEmployee?.mobileNumber}
                  onChange={(event: any) => {
                    setSelectedEmployee({
                      ...selectedEmployee,
                      mobileNumber: event.target.value,
                    });
                  }}
                  disabled
                />
              </Col>
            </Row>
          </div>
        )}
        <div className="inner-div">
          <Label className="header-style">Lead Details</Label>
          <Row className="mt-1">
            <Col xs={12} md={4}>
              <MTextField
                label="Lead Name"
                required
                value={leadDetails.name}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  setLeadDetails({
                    ...leadDetails,
                    name: inputValue,
                  });
                }}
                disabled={disabled}
              />
            </Col>
            <Col xs={12} md={4} className="col-margin">
              <MTextField
                label="Contact Number"
                required
                value={leadDetails.contactNumber}
                onChange={(data) => {
                  if (data.target.value.length <= 10) {
                    setLeadDetails({
                      ...leadDetails,
                      contactNumber: data.target.value,
                    });
                  }
                }}
                disabled={disabled}
              />
            </Col>
          </Row>
          <div className="mt-4">
            <MUILocationFilter
              size={{
                zone: colSize,
                state: colSize,
                district: colSize,
                city: colSize,
              }}
              filterData={{
                zone: locationData.zone,
                state: locationData.state,
                district: locationData.district,
                city: locationData.city,
              }}
              setLocationFilter={(filter: MUILocationFilterType) => {
                setLocationData({
                  ...locationData,
                  zone: filter.zone,
                  state: filter.state,
                  district: filter.district,
                  city: filter.city,
                  pincode: filter.pincode ?? '',
                });
              }}
              disabled={disabled}
              required={true}
              defaultLocationOptions={defaultLocationOptions}
            />
          </div>
          <Row className="mt-4">
            <Col xs={12} md={3}>
              <MTextField
                label="Pincode"
                required
                value={locationData.pincode ?? ''}
                numberOnly
                disabled
              />
            </Col>
          </Row>
        </div>
        <div className="inner-div">
          <Label className="header-style">Others</Label>
          <Row className="mt-1">
            <Col xs={12} md={6} className="task-date-picker">
              <MDatePicker
                label="Registration Date and Time"
                value={completionDateTime}
                onChange={setCompletionDateTime}
                disabled={disabled}
                icon={<Image src={Calendar}></Image>}
                maxDate={moment()}
              />
            </Col>
            <Col xs={12} md={6} className="col-margin">
              <MSelect
                label="Status of the Lead"
                disabled={
                  optionTaskStatus == LEAD_STATUS_OPTIONS.NEW ||
                  !!(
                    leadToView?.leadId &&
                    leadToViewDetails?.leadStatus !==
                      LEAD_STATUS_OPTIONS.FOLLOW_UP
                  )
                }
                options={leadStatusDropOptions}
                onChange={(e) => {
                  setOptionTaskStatus(e.target.value);
                }}
                value={optionTaskStatus ?? ''}
              />
            </Col>
          </Row>
        </div>

        {leadStatus !== TASK_ACTION.CREATE && (
          <Row className="mb-5">
            <Col xs={12} md={6} className="activity-log-margin">
              <Label className="model-comment-title mt-2 activity-level">
                Activity Log
              </Label>
              <div className="activity-log-div">
                <ul className="ul-item task-log-value">
                  {leadToViewDetails?.notes.map((noteItem) => (
                    <li
                      className="mt-1"
                      key={`notes-${noteItem.notesid ?? noteItem.notesId}`}
                    >
                      {getNoteDate(noteItem)}
                      {noteItem.notesDescription}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col xs={12} md={6} className="activity-log-margin create-input">
              <div className="mb-2">
                <Label for="comment" className="model-comment-title mt-2">
                  Comments
                </Label>
                <Input
                  id="comment"
                  name="comment"
                  type="textarea"
                  value={comment}
                  maxLength={250}
                  className="rounded border model-comment-area comment-input"
                  onChange={(event) => {
                    setComment(event.target.value);
                  }}
                />
              </div>
              <div className="d-flex justify-content-end">
                <Image
                  className="me-2 cursor-pointer"
                  src={Cancel}
                  onClick={() => {
                    setComment('');
                  }}
                />
                {'    '}
                <Image
                  alt="imgSaveComment"
                  className="me-2 cursor-pointer"
                  src={
                    showLoader || !comment ? DisablesuccessTick : successTick
                  }
                  onClick={() => {
                    if (!(showLoader || !comment))
                      saveComment(
                        {
                          comment,
                          leadUniqueId,
                          leadToViewDetails,
                        },
                        setShowLoader,
                        dispatch,
                        setLeadToViewDetails,
                        handleLeadsData,
                        setComment
                      );
                  }}
                />
              </div>
            </Col>
          </Row>
        )}

        {(!leadStatus || leadStatus === TASK_ACTION.CREATE) && (
          <Row>
            <Col xs={12} md={6} className="create-comment-parent">
              <FormGroup className="comment-input">
                <Label for="comment" className="model-comment-title mt-2">
                  Comments
                </Label>
                <Input
                  id="comment"
                  name="comment"
                  type="textarea"
                  value={comment}
                  maxLength={250}
                  className="rounded border model-comment-area comment-input"
                  onChange={(event) => {
                    setComment(event.target.value);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        )}
        <div className="d-flex justify-content-center bottom-button">
          <Button
            variant="primary"
            className="cl-btn-primary-custom mt-2"
            disabled={
              showLoader ||
              (leadStatus !== TASK_ACTION.CREATE &&
                optionTaskStatus === leadToViewDetails?.leadStatus)
            }
            onClick={() => {
              if (leadStatus === TASK_ACTION.CREATE) {
                createLead(
                  {
                    leadDetails,
                    completionDateTime,
                    selectedEmployee,
                    selectedLeadTypeId,
                    locationData,
                    comment,
                  },
                  setShowLoader,
                  dispatch,
                  clearFields
                );
              } else {
                updateLeadStatus(
                  {
                    leadId: leadUniqueId,
                    comments: comment ?? '',
                    leadStatus: optionTaskStatus,
                  },
                  leadToViewDetails,
                  optionTaskStatus,
                  setShowLoader,
                  dispatch,
                  handleLeadsData,
                  setLeadToViewDetails
                );
              }
            }}
          >
            {leadStatus === TASK_ACTION.CREATE
              ? 'Create Lead'
              : 'Update Status'}
          </Button>
          <Button
            variant="primary-outline"
            className=" mt-2 mx-4"
            onClick={() => {
              if (leadStatus === TASK_ACTION.CREATE) {
                navigateToViewListPage();
              } else if (onTaskAction)
                onTaskAction(CLICK_ACTIONS.CLOSE_VIEW_LEAD);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
      <CenterSpinner showLoader={showLoader} />
    </div>
  );
};

export default CreateLeadPage;
